const removeFromFilterStringHof = (filtersStateObject: any) => (filterName: string) => {
    return (filtersStateObject.filter || "")
        .split(",")
        .filter((filterStr: string) => {
            return filterStr.split(";")[0] !== filterName;
        })
        .join(",");
};

const createFilterStringHof = (filtersStateObject: any) => (filter: any) => {
    return [...(filtersStateObject.filter || "").split(",").filter((x: any) => x), filter].join(",");
};

export const filterQueryParamBuilder = (queryParams: {
    category?: string;
    sourceType?: string;
    domain?: string;
}): string => {
    const { category, domain, sourceType } = queryParams;
    const filters = [];
    if (sourceType) {
        filters.push(`sourceType;==;"${sourceType}"`);
    }
    if (category) {
        filters.push(`category;category;"${category}"`);
    }
    if (domain) {
        filters.push(`Domain;contains;"${domain}"`);
    }
    const filter = filters.join(",");
    return filter;
};
